document.addEventListener('DOMContentLoaded', function (event) {
  const pageBody = document.getElementsByTagName('body')[0];
  const modal = document.querySelector('.dialog-off-canvas-main-canvas .modal');

  document.querySelectorAll('button.newsletter').forEach((item) => {
    item.addEventListener('click', () => {
      pageBody.classList.remove('mobile-nav-open');
      document.body.classList.add('modal');
      modal.style.display = 'grid';
    });
  });

  const close = document.querySelector('.block-newsletter .close');

  close.addEventListener('click', () => {
    document.body.classList.remove('modal');
    modal.style.display = 'none';
  });
});
